import { ThemeOptions } from '@mui/material';
import { MuiButton, MuiButtonBase } from './button';
import { MuiCheckbox } from './checkbox';
import { MuiLink } from './link';
import { MuiInputBase, MuiOutlinedInput } from './input';
import { MuiSelect } from './select';
import { MuiAutocomplete } from './autocomplete';
import { MuiInputLabel } from './label';
import { MuiFormLabel, MuiFormHelperText, MuiFormControlLabel, MuiFormGroup } from './form';
import { MuiMenuItem } from './menu-item';
import { MuiCssBaseline } from './baseline';
import { MuiChip } from './chip';
import { MuiBackdrop } from './backdrop';
import { MuiTooltip } from './tooltip';
import { MuiIconButton } from './iconButton';
import { MuiDialog, MuiDialogTitle, MuiDialogActions, MuiDialogContent, MuiDialogContentText } from './dialog';
import { MuiTextField } from './text-field';
import { MuiBreadcrumbs } from './breadcrumbs';
import { MuiDatePicker, MuiDateCalendar, MuiYearCalendar, MuiPickersDay, MuiPickersYear } from './date-picker';
import { MuiAlert } from './alert';
import { MuiSvgIcon } from './svgIcon';
import { MuiSnackbar, MuiSnackbarContent } from './snackbar';
import { MuiCircularProgress } from './progress';
import { MuiTab, MuiTabs } from './tabs';
import { MuiMobileStepper } from './stepper';
import { MuiRadio } from './radio';
import { MuiUnorderedList, MuiUnorderedListItem } from './unordered-list';
import { MuiOrderedList, MuiOrderedListItem } from './ordered-list';

export const components: ThemeOptions['components'] = {
    MuiButton,
    MuiButtonBase,
    MuiCheckbox,
    MuiLink,
    MuiInputBase,
    MuiSelect,
    MuiInputLabel,
    MuiOutlinedInput,
    MuiMenuItem,
    MuiAutocomplete,
    MuiFormLabel,
    MuiFormControlLabel,
    MuiFormHelperText,
    MuiFormGroup,
    MuiCssBaseline,
    MuiChip,
    MuiBackdrop,
    MuiTooltip,
    MuiIconButton,
    MuiDialog,
    MuiDialogTitle,
    MuiDialogActions,
    MuiTextField,
    MuiDialogContent,
    MuiDialogContentText,
    MuiBreadcrumbs,
    MuiDatePicker,
    MuiDateCalendar,
    MuiYearCalendar,
    MuiPickersDay,
    MuiPickersYear,
    MuiAlert,
    MuiSvgIcon,
    MuiSnackbar,
    MuiSnackbarContent,
    MuiCircularProgress,
    MuiTabs,
    MuiTab,
    MuiMobileStepper,
    MuiRadio,
    MuiUnorderedList,
    MuiUnorderedListItem,
    MuiOrderedList,
    MuiOrderedListItem,
};
